import HomePage from './HomePage';
import './HomePage.scss';

export default HomePage;
